import { useEffect, useRef } from "react";

// Cloudflare Turnstile (Managed mode). Renders nothing when no site key is configured, so preview keeps working.
export function TurnstileWidget({ siteKey, onToken, testId = "turnstile-widget", className = "mt-4" }) {
  const ref = useRef(null);
  const widgetId = useRef(null);
  useEffect(() => {
    if (!siteKey || !ref.current) return undefined;
    const render = () => {
      if (!ref.current || widgetId.current !== null) return;
      widgetId.current = window.turnstile?.render(ref.current, {
        sitekey: siteKey, theme: "dark", appearance: "always", "refresh-expired": "auto",
        callback: onToken, "expired-callback": () => onToken(null), "error-callback": () => onToken(null),
      });
    };
    if (window.turnstile) { render(); }
    else {
      let s = document.querySelector('script[data-turnstile="1"]');
      if (!s) { s = document.createElement("script"); s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit"; s.async = true; s.dataset.turnstile = "1"; document.head.appendChild(s); }
      s.addEventListener("load", render);
    }
    return () => { if (widgetId.current !== null && window.turnstile) { try { window.turnstile.remove(widgetId.current); } catch { /* already gone */ } widgetId.current = null; } };
  }, [siteKey, onToken]);
  return siteKey ? <div ref={ref} className={className} data-testid={testId} /> : null;
}
